var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Box from "onnit-ui/lib/box/Box";
var ProductImage = function (_a) {
    var imageUrl = _a.imageUrl, productUrl = _a.productUrl, productName = _a.productName, children = _a.children, _b = _a.width, width = _b === void 0 ? "75px" : _b, onClick = _a.onClick, boxProps = __rest(_a, ["imageUrl", "productUrl", "productName", "children", "width", "onClick"]);
    var image = (React.createElement("img", { src: imageUrl, alt: productName, width: "100%" }));
    return (React.createElement(Box, __assign({ mr: 3, position: "relative", flex: "none", width: width }, boxProps),
        children && children,
        productUrl ? (React.createElement("a", { href: productUrl, onClick: onClick }, image)) : image));
};
export default ProductImage;
//# sourceMappingURL=ProductImage.js.map